import React, { useState, useCallback } from "react";

const ActivityComposer = ({ onCreate, busy }) => {
  const [activityType, setActivityType] = useState("task");
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [dueAt, setDueAt] = useState("");

  const handleSubmit = useCallback(() => {
    if (!subject.trim()) return;

    onCreate({
      activity_type: activityType,
      subject: subject.trim(),
      description: description.trim(),
      due_at: dueAt ? new Date(dueAt).toISOString() : null,
    });

    setActivityType("task");
    setSubject("");
    setDescription("");
    setDueAt("");
  }, [activityType, subject, description, dueAt, onCreate]);

  return (
    <div className="crm-activity-composer">
      <div className="crm-activity-composer-header">
        <div>
          <p className="crm-activity-composer-subtitle">
            Log a follow-up, note, meeting, or collection action.
          </p>
        </div>
      </div>

      <div className="crm-activity-composer-grid">
        <div className="crm-form-group">
          <label>Activity Type</label>
          <select
            className="crm-select crm-activity-select"
            value={activityType}
            onChange={(event) => setActivityType(event.target.value)}
          >
            <option value="task">Task</option>
            <option value="call">Call</option>
            <option value="meeting">Meeting</option>
            <option value="note">Note</option>
            <option value="collection">Collection</option>
          </select>
        </div>

        <div className="crm-form-group">
          <label>Due Date & Time</label>
          <input
            className="crm-input crm-activity-input"
            type="datetime-local"
            value={dueAt}
            onChange={(event) => setDueAt(event.target.value)}
          />
        </div>
      </div>

      <div className="crm-form-group">
        <label>Subject</label>
        <input
          className="crm-input crm-activity-input"
          value={subject}
          onChange={(event) => setSubject(event.target.value)}
          placeholder="Enter activity subject"
        />
      </div>

      <div className="crm-form-group">
        <label>Description</label>
        <textarea
          className="crm-textarea crm-activity-textarea"
          value={description}
          onChange={(event) => setDescription(event.target.value)}
          placeholder="Add context, next steps, or discussion notes"
          rows={4}
        />
      </div>

      <div className="crm-inline-actions">
        <button
          className="crm-primary-btn crm-activity-submit"
          onClick={handleSubmit}
          disabled={busy}
        >
          {busy ? "Saving..." : "Save Activity"}
        </button>
      </div>
    </div>
  );
};

export default ActivityComposer;
